$(function(){
  var webStorage = function(){
    if(sessionStorage.getItem('access')){
      // 2回目以降はローディングをスキップ
      $('#bobson_loader_motion').hide();
      $('#bobson_pageloader-bg').hide();
      $('#bobson_pageloader').hide();
      $('#bobson_pagewrap').css({
        'opacity': 1,
        'visibility': 'visible'
      });
      $('.header-view2, .header-view2 *').not('.view-black').css('opacity', 1);
      $('.header-logo_pc, .header-logo_pc *').css('opacity', 1);
    } else {
      // 初回はローディングを実行
      var h = $(window).height();
      $('#bobson_pageloader-bg, #bobson_pageloader').height(h).css('display','block');

      $(window).on('load', function(){
        setTimeout(function(){
          $('#bobson_loader_motion').delay(900).fadeOut(700);
          $('#bobson_pageloader-bg').delay(900).fadeOut(800);
          $('#bobson_pageloader').delay(800).fadeOut(1000);
          if (typeof myGsapInit === "function") {
            myGsapInit();
          }
          $('#bobson_pagewrap').css({
            'opacity': 1,
            'visibility': 'visible'
          });
          $('.header-view2, .header-view2 *').not('.view-black').css('opacity', 0).animate({ opacity: 1 }, 1500);
          $('.header-logo_pc, .header-logo_pc *').css('opacity', 0).animate({ opacity: 1 }, 2300);

          if($(window).width() <= 600){
            setTimeout(setupClipPath, 100);
          }
        }, 1500);
      });

      // 初回アクセス済みフラグをセット
      sessionStorage.setItem('access', 'true');
    }
  }
  webStorage();
});

function setupClipPath(){
    $(".timeline-img").each(function(index){
        var sp_img_height = $(".timeline-img__item").height();
        var margin = (sp_img_height / 5) - 10;
        if(index != 0) {
            $(this).css("margin-top", "-" + margin +"px");
        }
    });
    $(".timeline-text div").each(function(index){
        var sp_text_height = $(".timeline-img__item").height();
        var margin = (sp_text_height / 5) - 10;
        if(index !== 0) {
            $(this).css("margin-top", "-" + margin + "px");
        }
    });
    $(".timeline-img__item").each(function(index){
        var sp_img_width = $(this).width();
        var sp_img_height = $(this).height();
        console.log("clip-path:", index, sp_img_width, sp_img_height);
        var wd_center = sp_img_width / 2;
        var wd_max = sp_img_width;
        var ht_allow = sp_img_height / 5;
        var ht_allow2 = sp_img_height - ht_allow;
        var ht_max = sp_img_height;
        let zahyou;
        if(index == 0) {
            zahyou = `polygon(
                0px 0px,
                ${wd_max}px 0px,
                ${wd_max}px ${ht_allow2}px,
                ${wd_center}px ${ht_max}px,
                0px ${ht_allow2}px
            )`;
        } else {
            zahyou = `polygon(
                0px 0px,
                ${wd_center}px ${ht_allow}px,
                ${wd_max}px 0,
                ${wd_max}px ${ht_allow2}px,
                ${wd_center}px ${ht_max}px,
                0 ${ht_allow2}px
            )`;
        }
        $(this).css("clip-path", zahyou);
        $(this).css("background-position", "center");
    })
}
$(window).on('load',function () {
  var target = $(".timeline-img, .timeline-text__item");
  if (window.matchMedia("(max-width: 600px)").matches) {
    function scroll_show() {
      var windowHeight = $(window).height();
      var windowTop = $(window).scrollTop();
      var visible = 0;

      target.each(function () {
        var item = $(this);
        var itemTop = item.offset().top;
        var itemBottom = itemTop + item.height();

        if (itemTop < windowTop + windowHeight && itemBottom > windowTop) {
          if (!item.hasClass("show")) {
            if (item.hasClass("timeline-img")) {
              setTimeout(function () {
                item.addClass("show");
              }, visible * 300);
            } else if (item.hasClass("timeline-text__item")) {
              setTimeout(function () {
                item.addClass("show");
              }, (visible + 1) * 100);
            }
            visible++;
          }
        }
      });
    }
    $(window).on("scroll", function () {
      scroll_show();
    });
    scroll_show();
  }

  $(".timeline-svg").on("click", function () {
      var btnId = $(this).attr("id").replace("timeline-svg", "");
      var $container = $("#container");
      var $target = $("#timeline-img" + btnId);
      var container = $container[0];
      var target = $target[0];
      var targetCenter = target.offsetLeft + (target.offsetWidth / 2);
      var containerCenter = container.clientWidth / 2;
      var scrollTo = targetCenter - containerCenter;
  
      if (Math.abs(container.scrollLeft - scrollTo) > 1) {
          $container.animate({
              scrollLeft: scrollTo
          }, 800);
      }
  });

  // SP表示用トリミング
  // var window_wd = $(window).width();
  // if(window_wd <= 600){
  //   $(".timeline-img").each(function(index){
  //     console.log( $(this).width(), $(this).height() );
  //     var sp_img_height = $(".timeline-img__item").height();
  //     var margin = (sp_img_height / 5) - 10;
  //     if(index != 0) {
  //       $(this).css("margin-top", "-" + margin +"px");
  //     }
  //   })
  //   $(".timeline-text div").each(function(index){
  //     var sp_text_height = $(".timeline-img__item").height();
  //     var margin = (sp_text_height / 5) - 10;
  //     if(index !== 0) {
  //       $(this).css("margin-top", "-" + margin + "px");
  //     }
  //   });
  //   $(".timeline-img__item").each(function(index){
  //     var sp_img_width = $(this).width();
  //     var sp_img_height = $(this).height();
  //     // width
  //     var wd_center = sp_img_width / 2;
  //     var wd_max = sp_img_width;
  //     // height
  //     var ht_top = 0;
  //     var ht_allow = sp_img_height / 5;
  //     var ht_allow2 = sp_img_height - ht_allow;
  //     var ht_max = sp_img_height;
  //     let zahyou;
  //     if(index == 0) {
  //       zahyou = `polygon(
  //         0px 0px,
  //         ${wd_max}px 0px,
  //         ${wd_max}px ${ht_allow2}px,
  //         ${wd_center}px ${ht_max}px,
  //         0px ${ht_allow2}px
  //       )`;
  //     } else {
  //       zahyou = `polygon(
  //         0px 0px,
  //         ${wd_center}px ${ht_allow}px,
  //         ${wd_max}px 0,
  //         ${wd_max}px ${ht_allow2}px,
  //         ${wd_center}px ${ht_max}px,
  //         0 ${ht_allow2}px
  //       )`;
  //     }
  //     $(this).css("clip-path", zahyou);
  //     $(this).css("background-position", "center");
  //   })
  // }
});
$(function () {
  $(".timeline-btn svg polygon").on("mouseenter", function () {
    $(this).closest("svg").find("text").css("fill", "#fff");
  });
  $(".timeline-btn svg polygon").on("mouseleave", function () {
    $(this).closest("svg").find("text").css("fill", "#818181");
  });
});